import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import useAuth from "hooks/useAuth";
import { AppState } from "index";
import { fetchArchive, fetchMidiArchive } from "api/generations.api";

interface DownloadArchiveButtonProps {
  variant: "rhithm" | "synth" | "bass";
  format: "midi" | "wav";
}

const get_filename = () => {};

export function DownloadArchiveButton(props: DownloadArchiveButtonProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const state = useContext(AppState);
  const { auth } = useAuth();

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      if (props.format === "midi") {
        const response = await fetchArchive(
          auth,
          "standard",
          props.variant !== "rhithm"
            ? props.variant === "synth"
              ? state.generatedSynthPath.value.result_id
              : state.generatedBassPath.value.result_id
            : state.generatedNames.value.result_id,

          props.variant
        );
        if (!response) return;
        let filename = "default_archive.zip"; // Имя по умолчанию

        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
            contentDisposition
          );
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, ""); // Удаляем кавычки
          }
        }

        const resUrl = URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );
        const link = document.createElement("a");
        link.href = resUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(resUrl);
      }
      if (props.format === "wav") {
        const response = await fetchMidiArchive(
          auth,
          state.generatedNames.value.result_id
        );
        let filename = "default_archive.zip"; // Имя по умолчанию
        if (!response) return;

        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
            contentDisposition
          );
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, ""); // Удаляем кавычки
          }
        }
        const resUrl = URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );
        const link = document.createElement("a");
        link.href = resUrl;

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(resUrl);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  return (
    <>
      {(props.variant === "rhithm" &&
        state.generatedNames.value.result_id !== "") ||
      (props.variant === "synth" &&
        state.generatedSynthPath.value.result_id !== "") ||
      (props.variant === "bass" &&
        state.generatedBassPath.value.result_id !== "") ? (
        <Button variant="contained" onClick={handleDownload}>
          {!isLoading ? (
            `${props.format === "wav" ? "all_" : ""}${
              props.variant === "bass" ? "" : props.format
            }.zip`
          ) : (
            <Stack direction="row" spacing={1} alignItems="center">
              <CircularProgress />
              <Typography>Loading...</Typography>
            </Stack>
          )}
          <DownloadIcon />
        </Button>
      ) : (
        <></>
      )}
    </>
  );
}
